const BASE_SELECTOR: string = "[data-game]";
const GAME_SUBMIT_SELECTOR: string = "[data-game-submit]";
const GAME_SELECT_SELECTOR: string = "select";

const LOADING_CLASSNAME: string = "gameserver--loading";
const OPEN_CLASSNAME: string = "is-open";

export class GameUI {
  public constructor(private $base: JQuery) {}

  public onOpenSelect(callback: () => {}) {
    this.$base.find(GAME_SELECT_SELECTOR).on('click', () => {
      callback();
    });
  }

  public onSubmit(callback: () => {}) {
    this.$base.find(GAME_SUBMIT_SELECTOR).on('click', () => {
      callback();
    })
  }

  public disableButton() {
    this.$base.find(GAME_SUBMIT_SELECTOR).attr('disabled', 'disabled');
  }

  public enableButton() {
    this.$base.find(GAME_SUBMIT_SELECTOR).removeAttr('disabled');
  }

  public block() {
    this.$base.addClass(OPEN_CLASSNAME);
  }

  public unblockAll() {
    $(BASE_SELECTOR).removeClass(OPEN_CLASSNAME);
  }

  public loading(state: boolean) {
    if (state) {
      this.$base.addClass(LOADING_CLASSNAME);
    } else {
      this.$base.removeClass(LOADING_CLASSNAME);
    }
  }

  public getOrderId() {
    return this.$base.data('orderid');
  }

  public getServerId() {
    return this.$base.data('serverid');
  }

  public getSlots() : string {
    return this.$base.find('select').val() as string;
  }

}

export function createGameUIInstances() : GameUI[] {
  const $base = $(BASE_SELECTOR);
  const instances: GameUI[] = [];

  $base.each((i, el) => {
    instances.push(new GameUI($(el)));
  });

  return instances;
}
